import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { urlMaker } from "utils";
import { onResponseUpdateEmployee } from "./helpers";

export const updateEmployee = async ({ id, role, force }: UpdateEmployeeReqT) =>
  axios.put(urlMaker(Routes.UPDATE_EMPLOYEE, id), { role_id: role.id, force });

export const useUpdateEmployee = () =>
  useMutation({
    mutationKey: [Keys.UPDATE_EMPLOYEE],
    mutationFn: updateEmployee,
    onSettled: onResponseUpdateEmployee,
    cacheTime: Infinity,
  });
